<button
  type="button"
  mat-button
  (click)="togglePresetMenu($event)"
  [matMenuTriggerFor]="menu"
>
  Apply Preset <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button
    *ngFor="let preset of shippingPresets; trackBy: trackById"
    (click)="onSelectPreset(preset)"
    mat-menu-item
  >
    {{ preset.name }}
  </button>
  <mat-divider></mat-divider>
  <button (click)="onManagePreset()" mat-menu-item>Manage Presets</button>
</mat-menu>
